import { CommonModule } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AngularSvgIconModule } from 'angular-svg-icon';

import { HeaderDesktopModule } from './header-desktop/header-desktop.module';
import { HeaderMobileModule } from './header-mobile/header-mobile.module';
import { HeaderComponent } from './header.component';

@NgModule({
	declarations: [HeaderComponent],
	exports: [HeaderComponent],
	imports: [
		AngularSvgIconModule.forRoot(),
		CommonModule,
		HeaderDesktopModule,
		HeaderMobileModule,
	],
	providers: [provideHttpClient()],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderModule {}
